import { render, staticRenderFns } from "./productcenterzyjy.vue?vue&type=template&id=7ba1f890&scoped=true&"
import script from "./productcenterzyjy.vue?vue&type=script&lang=js&"
export * from "./productcenterzyjy.vue?vue&type=script&lang=js&"
import style0 from "./productcenterzyjy.vue?vue&type=style&index=0&id=7ba1f890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba1f890",
  null
  
)

export default component.exports